// extracted by mini-css-extract-plugin
module.exports = {"searchContent":"kM","content":"kN","navigation":"kO","mainPanel":"kP","footer":"kQ"};